import {connect} from "react-redux";
import AdminMenu from "./AdminMenu.jsx";
import {fetchInGameMenuAction, fetchGeneralMenuAction} from "./adminMenuActions";

const mapStateToProps = (state, {game}) => {
    if (state.user.permissionLevel < 4) {
        return {
            show: false
        }
    }
    return {
        ...state.adminMenu,
        show: true,
        gameId: game ? game.id : null
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        loadInGame: id => dispatch(fetchInGameMenuAction(id)),
        loadGeneral: () => dispatch(fetchGeneralMenuAction())
    }
};

const AdminMenuContainer = connect(
    mapStateToProps,
    mapDispatchToProps
)(AdminMenu);

export default AdminMenuContainer